import{jsxs as e,Fragment as t,jsx as i}from"react/jsx-runtime";import r from"@atlaskit/spinner";import n from"styled-components";import"@atlaskit/datetime-picker";import{TextInput as o}from"../../input/text/Input.js";import"../../../../_virtual/_tslib.js";import"react";import"sanitize-html";import a from"../icons/CloseIcon.js";import s from"../icons/SearchIcon.js";import{InputField as c,InputIcon as l,CloseButton as p}from"./IconPicker/styled/Components.js";const m=n.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	margin-top: 15px;
`,d=n.div`
	text-align: center;
	padding-top: 25px;
`,h=n.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	gap: 0.25rem;
	padding: 10px;
	border-radius: 10px;
	transition: transform 0.1s ease-in, background 0.1s ease-in;

	&:hover {
		background: rgba(0, 0, 0, 0.05);
		transform: scale(0.95);
		cursor: pointer;
	}

	background: ${({isActive:e})=>e?"#DEEBFF !important":"transparent"};
`,g=n.div`
	img {
		height: 32px;
	}
`,u=n.div`
	font-size: 11px;
	font-family: 'PP Formula';
`,f=({appIcon:n,appIcons:f,onIconSelect:x,searchValue:v,setSearchValue:k})=>{const b=f||[];return e(t,{children:[e(c,{children:[i(o,{placeholder:"Search",value:v||"",onChange:k}),i(l,{children:v?i(p,Object.assign({onClick:()=>k("")},{children:i(a,{})})):i(s,{})})]}),b.length?i(m,{children:b.filter((e=>!v||e.title.toLowerCase().includes(v.toLowerCase()))).map((t=>e(h,Object.assign({isActive:n===t.path,onClick:()=>x(t)},{children:[i(g,{children:i("img",{src:t.path,alt:t.title})}),i(u,{children:t.title})]}),t.id)))}):i(d,{children:i(r,{size:"large"})})]})};export{f as AppPicker};
